// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hK","message":"hL","close":"hM","closeMessage":"hN","closeIcon":"hO"};